module.exports = __webpack_public_path__ + "static/media/img.227e9aed.png";